module.exports = __webpack_public_path__ + "static/media/signin.58ee1d5a.svg";